import axios from "axios";

import { ensureCsrfCookie } from "./csrf";
import { isSessionAuthFailure, retryRequestAfterCsrfRefresh } from "./sessionAuth";

export { ensureCsrfCookie };

let unauthorizedHandler: (() => void) | null = null;

function inferApiOrigin() {
    if (typeof window === "undefined") {
        return null;
    }

    return null;
}

const inferredApiOrigin = inferApiOrigin();

const apiBaseUrl = import.meta.env.DEV
    ? "/api"
    : (import.meta.env.VITE_API_URL ?? (inferredApiOrigin ? `${inferredApiOrigin}/api` : "/api"));

export const apiClient = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
});

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (!axios.isAxiosError(error)) {
            return Promise.reject(error);
        }

        const retried = await retryRequestAfterCsrfRefresh(error);

        if (retried) {
            return retried;
        }

        if (isSessionAuthFailure(error)) {
            unauthorizedHandler?.();
        }

        return Promise.reject(error);
    },
);

export function registerUnauthorizedHandler(handler: (() => void) | null) {
    unauthorizedHandler = handler;

    return () => {
        if (unauthorizedHandler === handler) {
            unauthorizedHandler = null;
        }
    };
}

export async function fetchBackendHealth() {
    const response = await apiClient.get<import("./types/common").BackendHealthResponse>("/health");

    return response.data;
}
